import api from './'

export default {

    /**
     * Show calendar
     * @param calendarId
     */
    show(calendarId, params) {
        return api
            .get(`/calendars/${calendarId}`, {
                params: params
            })
            .then(response => {
                return response.data
            });
    },

    /**
     * Update calendar
     * @param calendarId
     * @param data
     */
    update(calendarId, data) {
        return api
            .put(`/calendars/${calendarId}`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Delete calendar
     * @param calendarId
     */
    delete(calendarId) {
        return api
            .delete(`/calendars/${calendarId}`)
            .then(response => {
                return response.data
            })
    },

    /**
     * Clone calendar
     * @param calendarId
     * @param data
     */
    clone(calendarId, data) {
        return api
            .post(`/calendars/${calendarId}/clone`, data)
            .then(response => {
                return response.data
            });
    },

    /**
     * Get events of a calendar
     * @param calendarId
     * @param params
     */
    getEvents(calendarId, params) {
        return api
            .get(`/calendars/${calendarId}/events`, {
                params: params
            })
            .then(response => {
                return response.data
            });
    },

    /**
     * Add event to calendar
     * @param calendarId
     * @param data
     */
    addEvent(calendarId, data) {
        return api
            .post(`/calendars/${calendarId}/events/add`, data)
            .then(response => {
                return response.data
            });
    },

    /**
     * Add busy event to calendar
     * @param calendarId
     * @param data
     */
    addBusyEvent(calendarId, data) {
        return api
            .post(`/calendars/${calendarId}/events/addBusy`, data)
            .then(response => {
                return response.data
            });
    }

}
